import AziendaDesktop from '@components/azienda/desktop/desktop';
import { useSiteData } from '../../context/site-data-context';

const mainSectionImageUrl = '/images/Azienda.png';

const navbarItems = [
  {
    title: 'Mission',
    target: 'mission'
  },
  {
    title: 'Storia',
    target: 'storia'
  },
  {
    title: 'Organizzazione',
    target: 'organization'
  },
  {
    title: 'Management',
    target: 'management'
  },
  {
    title: 'Certificazioni',
    target: 'certificazioni'
  },
  {
    title: 'Condizioni Generali',
    file: '/assets/condizioni-generali.pdf'
  }
];

const mainSectionDescriptions = {
  title: 'Sistemi Informativi',
  subtitle:
    'Accelera la trasformazione digitale di aziende pubbliche e private, grazie a competenze consolidate e tecnologie abilitanti'
};

export default function Azienda() {
  const { serviceCategories, technologyCategories } = useSiteData();
  return (
    <AziendaDesktop
      navbarItems={navbarItems}
      serviceCategories={serviceCategories}
      technologyCategories={technologyCategories}
      mainSectionImageUrl={mainSectionImageUrl}
      mainSectionDescriptions={mainSectionDescriptions}
      mainSectionDarkTheme
    />
  );
}
